<template>
  <div class="window">
    <div class="window__body _small _phone-number">
      <div class="window__wrapper">
        <div class="window__image">
          <img src="@/assets/img/registration-form-image.png" alt="registration-form-image">
        </div>
        <span class="window__title _big">{{ $t("first_step.pop.title") }}</span>
        <span class="window__sub-title">{{ $t("first_step.pop.descr") }}</span>
        <div class="window__input-wrapper">
          <input 
            type="text" 
            class="phoneInp input"
            :class="{errorinp: showError}"
            autocomplete = "off"
            list="autocompleteOff"
            maxlength="18"
            v-model="userPhone"
            placeholder="+_ (___) ___-__-__" 
            required
          >
          <span class="window__input-error" v-if="showError">{{ $t("first_step.pop.error") }}</span>
        </div>
        <div class="window__policy">
          <div class="window__policy-box">
            <label class="window__policy-box-container">
              <input type="checkbox" v-model="policyChecked">
              <span class="window__policy-box-checkmark"></span>
            </label>
          </div>
          <div class="window__policy-text">
            {{ $t("first_step.pop.policy.start") }} <a href="https://smartanalytics.io/ru/license/" target="_blank">{{ $t("first_step.pop.policy.dogovor") }}</a> {{ $t("first_step.pop.policy.second") }} {{ $t("first_step.pop.policy.third") }} <a href="https://smartanalytics.io/ru/policy/" target="_blank">{{ $t("first_step.pop.policy.policy") }}</a>
          </div>
        </div>
        <div class="btn-holder">
          <button
          @click="sendUserPhone"
          class="btn"
          :disabled = !canSend
          :class ="{'loader-btn' : isSendingPhone}"
          >
            {{ $t("first_step.pop.button") }}
          </button>
        </div>
      </div>
      <img class="registration-smiles" src="@/assets/img/bg-happy-1.png" alt="bg-happy-1">
      <img class="registration-smiles" src="@/assets/img/bg-happy-2.png" alt="bg-happy-2">
      <img class="registration-smiles" src="@/assets/img/bg-happy-3.png" alt="bg-happy-3">
      <img class="registration-smiles" src="@/assets/img/bg-happy-4.png" alt="bg-happy-4">
    </div>
  </div>
</template>

<script>
import { API, AUTH } from "@/constants.js";
import Inputmask from 'inputmask';
export default {
  data() {
    return {
      userId: "",
      regPhone: /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){9,18}(\s*)?$/,
      userPhone: "",
      validPhone: false,
      canSend: false,
      sendData: {},
      isSendingPhone: false,
      policyChecked: false,
      showError: false
    }
  },
  props:[
    'user'
  ],
  created(){
  },
  methods: {
    getUserId(){
      this.userId = this.$store.state.userId
    },
    createSendData(){
      this.sendData = {
        phone: this.userPhone
      }
    },
    sendUserPhone(){
      this.createSendData();
      this.getUserId();
      this.isSendingPhone = true;
      fetch(API.API_URL + AUTH.USER_LOGIN +
        this.userId + "/", {
        method: "PATCH",
          headers: {
            authorization: JSON.parse(this.$store.state.token),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.sendData),
      })
        .then(() => {
          this.getProfiles()
        })
        .catch((res) => {
          this.isSendingPhone = false;
          console.log(res);
        });
    },
    getProfiles() {
      fetch(API.API_URL + "profiles/", {
        method: "GET",
        headers: {
          authorization: JSON.parse(localStorage.getItem("authToken"))
        }
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          if(data.results[0].is_multisite){
            this.goToReports(data.results[0].id)
          } else {
            this.goToIntegrations(data.results[0].id)
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    goToReports(id) {
      localStorage.setItem("isCreateProject", true)
      window.location.href = AUTH.URL + this.$i18n.locale + "/#!/index/" + id + "/reports/1";
    },        
    goToIntegrations(id) {
      localStorage.setItem("isCreateProject", true)
      window.location.href = AUTH.URL + this.$i18n.locale + "/#!/index/" + id + "/integrations/all";
    },        
    phoneMask() {
      setTimeout(function () {
        let im = new Inputmask("+9 (999) 999-99-99");
        im.mask(document.querySelector('.phoneInp'));
      }, 500);
    },
    checkPhoneRepeat(){
      let phone = [...this.userPhone];
      let phoneArr = ((String(phone).replace(/[^0-9]/g,"")).split(''));
      phoneArr.shift();
      let dublArr = phoneArr.reduce(function (acc, el) {
        acc[el] = (acc[el] || 0) + 1;
        return acc;
      }, []);
      dublArr.forEach(el =>{
        if(el >= 10){
          this.showError = true;
          this.validPhone = false;
        } else {
          this.showError = false;
          this.validPhone = true;
        }
      })
    },
    isPhoneValid() {
      (this.userPhone == "") ? 
        this.validPhone = false : 
        (this.regPhone.test(this.userPhone)) ? 
          this.checkPhoneRepeat() : 
          this.validPhone = false;
    },
    isCanSend(){
      (this.validPhone && this.policyChecked) ? 
        this.canSend = true : 
        this.canSend = false;
    },
    replacer() {
      this.userPhone = this.userPhone.replace(/[^0-9+-^() ]/g, '');
    }    
  },
  watch:{
    userPhone(){
      this.isPhoneValid();
      this.isCanSend();
      this.replacer()
    },
    policyChecked(){
      this.isPhoneValid();
      this.isCanSend();
    }
  }
}
</script>

<style lang="sass" scoped></style>